module.exports = __webpack_public_path__ + "img/animate-2-2.14395f7a.png";